import React from 'react';
import memo from 'memoize-one';
import _isNil from 'lodash/isNil';
import _filter from 'lodash/filter';
import _join from 'lodash/join';
import _isEmpty from 'lodash/isEmpty';
import { Menu } from './styles';
import MenuTitle from './menu-title';
import { getMenuType } from './utils';

const createKey = memo((prev, next) => _join(_filter([prev, next], i => !_isNil(i)), '.'));

const createSubMenu = ({
  dataSource,
  components,
  previousKey,
}) => dataSource.map((menuEntry, nextKey) => {
  const currentKey = createKey(previousKey, nextKey);
  const menuType = getMenuType(menuEntry);
  const { MenuItem } = components;

  if (!_isEmpty(menuEntry.children)) {
    const { children, ...rest } = menuEntry;

    return (
      <Menu.SubMenu
        key={currentKey}
        title={<MenuTitle {...rest} />}
      >
        {createSubMenu({ dataSource: children, previousKey: currentKey, components })}
      </Menu.SubMenu>
    );
  }

  if (menuType === 'divider') {
    return <Menu.Divider key={currentKey} />;
  }

  return (
    <Menu.Item key={currentKey} entry={menuEntry}>
      <MenuItem key={currentKey} entry={menuEntry}>
        <MenuTitle {...menuEntry} />
      </MenuItem>
    </Menu.Item>
  );
});

export default memo(createSubMenu);
